var _defs, _path, _text, _line, _polygon, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostEffectiveArtboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#1292ee;stroke-miterlimit:10;}.cls-3{fill:#1292ee;font-family:ArialMT, Arial;font-size:52.27px;}.cls-2{stroke-linecap:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.4,35.48c-1.19-12.79-8.54-19.2-20.29-22.72-14.26-4.28-30.11,3.81-35.1,17.76-4.35,12.18.69,25.72,10.81,33.01,9.8,7.06,23.16,7.38,33.6.73"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(21.39 53.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "s"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.92,
    y1: 23.72,
    x2: 33.92,
    y2: 56.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.65 52.85 57.65 56.91 51.81 56.91 63.08 71.07 74.56 56.77 68.85 57.05 68.79 52.85 57.65 52.85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.62,
    y: 45.56,
    width: 11.12,
    height: 4.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.65,
    y: 38.49,
    width: 11.12,
    height: 3.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEffectiveArtboard);
export default __webpack_public_path__ + "static/media/Cost-EffectiveArtboard.0e6539ec1d5cb4663bf6876c0d69b385.svg";
export { ForwardRef as ReactComponent };